import comp from "./GenericCheckBoxView";
export default comp;
